import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const arctic: ThemeDefinition = {
  label: "Arctic",
  className: "theme-arctic",
  bg: "#0e1424",
  text: "#c8d8e8",
  textMuted: "rgba(200,216,232,0.55)",
  accent: "#d08060",
  glassRgb: "14,20,36",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(200,216,232,0.18)",
  selection: "#d08060",
  selectionText: "#0e1424",
  gridColor: "#c8d8e8",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#0e1424"),
  gpuGridLine: hexToLinear("#c8d8e8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#d08060"),
  gpuAxisZ: hexToLinear("#c8d8e8"),
  axisXColor: "#d08060",
  axisZColor: "#c8d8e8",
  font: '"Inter", sans-serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
};
